'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  computed: {
    isAuthLogin: function isAuthLogin() {
      var token = sessionStorage.getItem('authLogin');
      return token;
    }
  },
  methods: {
    isLogin: function isLogin(to, query) {
      var token = sessionStorage.getItem('authLogin');
      if (to && !token) {
        if (to != 'login') {
          this.$router.push({
            name: to,
            query: query || this.$route.query
          });
          return;
        }
        var historyQuery = (0, _stringify2.default)({
          name: this.$route.name,
          query: this.$route.query
        });
        sessionStorage.setItem('historyQuery', historyQuery);
        this.$store.commit('FLUSHCONTENT', 'login');
        //   this.$router.push({
        //     name: 'login'
        //   })
      }
      return token;
    }
  }
};